module.exports = __webpack_public_path__ + "04_short_yellow.6753da70.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/04_short_yellow.png
// module id = D7/T
// module chunks = 0